import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, InventarioIdentificacao } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InventarioIdentificacaoService extends BaseResourceService<InventarioIdentificacao> {

  constructor(
    protected injector: Injector
  ) {
    super(`inventario-identificacaos`, injector);
  }

  public cancelar(id: number, usuario: number, motivo_status: string): Observable<InventarioIdentificacao> {
    return this.http.post(`${this.login.cidade.id}/${this.api}/cancelar/${id}/${usuario}`, { motivo_status }, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public recusar(id: number, usuario: number, motivo_status: string): Observable<InventarioIdentificacao> {
    return this.http.post(`${this.login.cidade.id}/${this.api}/recusar/${id}/${usuario}`, { motivo_status }, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public confirmar(id: number, usuario: number): Observable<InventarioIdentificacao> {
    return this.http.post(`${this.login.cidade.id}/${this.api}/confirmar/${id}/${usuario}`, undefined, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }
}
